module.exports = __webpack_public_path__ + "img/sam_pass.5c0321e0.jpg";